// removed by extract-text-webpack-plugin
module.exports = {"publishButton":"_1k-wXhc3_Dy_y6W01AFb9w","iconCircle":"sExpWsXM_jCSQiA9tJpTn","plusIcon":"_1FcdsjRYS69o1uXhw-8FXW","primary":"_1ZRIMVEJBTQ9rBkvKAqhdn","omBlue":"_2fOkWBgFrY9dTGhOSdchIR","foreign":"_1rclyjyMejPAFlvOgjkE-c","small":"_3lFKz9sYfTqGYyJCzl77dU","medium":"JsqwTEgRR_NvJVRdskB-h","large":"_1elBzoILM40Njn5hgHpS3O","boldBorder":"_2LNN_LYbT1cB9ZTGTfhEKS","disabled":"yxS7iCDiDka-I2Lj-BUi4","caret":"_3--iD9QYMtBvmsXO7dvhtn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PublishPropertyButton/PublishPropertyButton.scss
// module id = 1741
// module chunks = 0